import React from 'react';
import { Container, Typography, Box, Grid, Card, CardContent } from '@mui/material';
import { Email, Phone } from '@mui/icons-material';

const Contact = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Box sx={{ textAlign: 'center', mb: 5 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
          Get in touch with us for any inquiries, questions, or support. We're here to help!
        </Typography>
      </Box>

      <Grid container spacing={4} justifyContent="center">
        {/* Contact Information Card */}
        <Grid item xs={12} md={8}>
          <Card 
            elevation={3}
            sx={{ 
              borderRadius: 2,
              background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(245, 245, 245, 0.9) 100%)',
            }}
          >
            <CardContent sx={{ p: 4 }}>
              <Typography 
                variant="h5" 
                component="h2" 
                gutterBottom 
                sx={{ mb: 4, textAlign: 'center', fontWeight: 600 }}
              >
                For any inquiries please email or call us
              </Typography>
              
              <Grid container spacing={3}>
                {/* Email */}
                <Grid item xs={12}>
                  <Box 
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      border: '1px solid',
                      borderColor: 'divider',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.02)',
                        transform: 'translateY(-2px)',
                        boxShadow: 2,
                      }
                    }}
                  >
                    <Email 
                      sx={{ 
                        fontSize: 32, 
                        color: 'primary.main', 
                        mr: 2 
                      }} 
                    />
                    <Box>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                        Email
                      </Typography>
                      <Typography 
                        component="a"
                        href="mailto:info@zaror.co.uk"
                        variant="h6"
                        sx={{ 
                          textDecoration: 'none',
                          color: 'text.primary',
                          fontWeight: 500,
                          '&:hover': {
                            color: 'primary.main',
                          }
                        }}
                      >
                        info@zaror.co.uk
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Phone 1 */}
                <Grid item xs={12} sm={6}>
                  <Box 
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      border: '1px solid',
                      borderColor: 'divider',
                      height: '100%',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.02)',
                        transform: 'translateY(-2px)',
                        boxShadow: 2,
                      }
                    }}
                  >
                    <Phone 
                      sx={{ 
                        fontSize: 32, 
                        color: 'primary.main', 
                        mr: 2 
                      }} 
                    />
                    <Box>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                        Phone
                      </Typography>
                      <Typography 
                        component="a"
                        href="tel:08006351020"
                        variant="h6"
                        sx={{ 
                          textDecoration: 'none',
                          color: 'text.primary',
                          fontWeight: 500,
                          '&:hover': {
                            color: 'primary.main',
                          }
                        }}
                      >
                        0800 635 1020
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Phone 2 */}
                <Grid item xs={12} sm={6}>
                  <Box 
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      p: 2,
                      borderRadius: 2,
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      border: '1px solid',
                      borderColor: 'divider',
                      height: '100%',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.02)',
                        transform: 'translateY(-2px)',
                        boxShadow: 2,
                      }
                    }}
                  >
                    <Phone 
                      sx={{ 
                        fontSize: 32, 
                        color: 'primary.main', 
                        mr: 2 
                      }} 
                    />
                    <Box>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                        Phone
                      </Typography>
                      <Typography 
                        component="a"
                        href="tel:01216901020"
                        variant="h6"
                        sx={{ 
                          textDecoration: 'none',
                          color: 'text.primary',
                          fontWeight: 500,
                          '&:hover': {
                            color: 'primary.main',
                          }
                        }}
                      >
                        0121 690 1020
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Contact;
